// Dank u chatgpt :)
const renderer = {
	google: undefined,

	render({count, position}) {
		let backgroundColor = window.getComputedStyle(document.body).getPropertyValue('--bs-secondary');
		let colorContrast = window.getComputedStyle(document.body).getPropertyValue('--bs-secondary-contrast');
		let color = colorContrast ? colorContrast : 'white';
		const clusterElement = document.createElement("div");
		clusterElement.style.backgroundColor = backgroundColor;
		clusterElement.style.borderRadius = "50%";
		clusterElement.style.width = "40px";
		clusterElement.style.height = "40px";
		clusterElement.style.display = "flex";
		clusterElement.style.alignItems = "center";
		clusterElement.style.justifyContent = "center";
		clusterElement.style.color = color;
		clusterElement.style.fontSize = "14px";
		clusterElement.style.fontWeight = "bold";
		clusterElement.style.boxShadow = "0 0 6px rgba(0,0,0,0.3)";
		clusterElement.textContent = String(count);

		return new this.google.maps.marker.AdvancedMarkerElement({
			position,
			content: clusterElement,
			zIndex: 1000 + count,
		});
	}
};

export default renderer;
